import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {getNorthCitiesIds} from "@models/area";
import GridCardImage from "./grid_card_image";
import {isEmpty} from "../../../helpers/helpers";
import GridCardPropertyInfo from "./grid_card_info";
import GridCardPropertyInfoPriceAndContact from "./grid_card_info_price_and_contact";
import {checkPropertyIsAssignedAndOwner, getPropertyUrl, handlePropertyPrice} from "../helpers/property_helpers";

const PropertyGridCard = ({property, isBadeSaba, selectedFiltersDistrict, handleShowProperty, selectedCityFilter, handleBookmark, bookmarkedProperties, categories, setContactInfo, setForceShowNoResult}) => {

    const [northCitiesIds, setNorthCitiesIds] = useState([]);

    useEffect(() => {
        if (!northCitiesIds.length) {
            getNorthCitiesIds().then(ids => {
                setNorthCitiesIds(ids);
            })
        }
    }, []);


    const {media, request_contact} = property;
    const pricing = handlePropertyPrice(property, true, northCitiesIds);
    const showRequestForm = (request_contact || isBadeSaba);
    const assignedAndIsOwner = checkPropertyIsAssignedAndOwner(property);

    let imgCount = 0, videoCount = 0;

    if (!isEmpty(media) && media.length) {
        for (let item of media) {
            if (item.type === 'video') {
                videoCount += 1;
            } else {
                imgCount += 1;
            }
        }
    }

    const handleShowNoResult = () => {
        setForceShowNoResult(true)
    };

    const handleClickOnContactButton = () => {
        if (!property.archived) {
            setContactInfo({
                show: true,
                property_id: property.id,
                city_id: property.city_id,
                district_id: property.district_id,
                realtor_id: null,
                agency_id: null,
                isAssignedProperty: assignedAndIsOwner,
                isOnList: true,
                exists_in_kanban: showRequestForm,
                isBadeSaba: isBadeSaba,
            })
        }
    };


    return (
        <div key={property.id} className="col-md-6 mt-md-16">

            <Card className={"mx-24 mx-md-0 d-flex align-items-start justify-content-between "}>
                {/* Link */}
                <Content className="d-flex flex-column" href={getPropertyUrl(property, isBadeSaba)} onClick={(e) => handleShowProperty(e, getPropertyUrl(property, isBadeSaba), ((!isEmpty(property.media) && property.media.length) ? property.media.length : 0))}>
                    <GridCardPropertyInfo
                        property={property}
                        selectedFiltersDistrict={selectedFiltersDistrict}
                        selectedCityFilter={selectedCityFilter}
                        videoCount={videoCount}
                    />

                    <GridCardPropertyInfoPriceAndContact
                        pricing={pricing}
                        property={property}
                    />
                </Content>

                <GridCardImage
                    property={property}
                    imgCount={imgCount}
                    videoCount={videoCount}
                    className="grid-view-property-image"
                    selectedCityFilter={selectedCityFilter}
                    handleShowProperty={handleShowProperty}
                    isBadeSaba={isBadeSaba}
                />
            </Card>

        </div>
    );
};

export default React.memo(PropertyGridCard);

// styles

const Card = styled.div`
  border: solid 1px ${props => props.theme.gray200};
  padding: 16px;
  border-radius: 8px;

  &:hover {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  }

  @media (max-width: ${props => props.theme.screenXsMax}) {
    border-left: none;
    border-right: none;
    border-bottom: none;
    padding: 16px 0;
    border-radius: 0;

    &:hover {
      box-shadow: none;
    }
  }
`;

const Content = styled.a`
  width: calc(100% - 208px);
  height: 130px;

  @media (max-width: ${props => props.theme.screenXsMax}) {
    width: calc(100% - 124px);
    height: 120px;
  }
`;